import { LayoutFeatureArea, ModelCategory } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

import { ModelSchema } from '../ModelSchema';

export const FeatureAreaSchema = new ModelSchema<LayoutFeatureArea>('featureArea', {
  category: ModelCategory.IntermediateModel,

  pluralName: 'Feature Areas',
  displayName: (item) => humanCase(item.featureType),

  properties: {},
  children: {},
});
